<template lang="html">
  <div class="profile-wrapper-background">
    <div class="profile-wrapper">
      <div
        class="profile-links"
        :style="{
          maxHeight: showNav ? 700 + 'px' : '0px'
        }"
        ref="profileLinks"
      >
        <!-- 1-->
        <router-link
          v-for="(link, index) in getLinks"
          :key="index"
          :to="{ name: link.link, params: { lang: $i18n.locale } }"
          class="link-wrapper"
          :ref="'link' + index"
        >
          <div class="image-wrapper">
            <div class="img-helper">
              <img :src="link.src" alt="icon" />
              <notification-counter
                v-if="link.counter && notificationsCount"
                :counter="notificationsCount"
              />
              <notification-counter
                v-if="link.counterMessage && messagesCount"
                :counter="messagesCount"
              />
            </div>
          </div>
          <span>{{ link.label }}</span>
        </router-link>
        <div v-if="userAdmin" class="link-wrapper admin">
          <router-link
            v-if="userAdmin"
            :to="{ name: 'Admin', params: { lang: $i18n.locale } }"
            >Admin</router-link
          >
        </div>
      </div>
      <div class="open-drawer" v-if="windowWidth <= 1000" @click="test">
        <Icon
          class="icon"
          icon="mdi:chevron-down"
          :class="{ rotate: showNav }"
        ></Icon>
      </div>
      <div class="content swing-in-top-fwd">
        <!--2 -->
        <keep-alive>
          <router-view class="swing-in-top-fwd"></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationCounter from "@/components/notificationCounter.vue";
import { mapState } from "vuex";
import { Icon } from "@iconify/vue2";
export default {
  name: "Profile",
  components: {
    NotificationCounter,
    Icon
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      showNav: true
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },

  computed: {
    ...mapState(["notificationsCount", "userAdmin", "messagesCount"]),

    getLinks() {
      return [
        {
          label: this.$t("profile.links.profile"),
          src: require("@/assets/newImges/profile/nav/profile.png"),
          link: "MyProfile"
        },
        {
          label: this.$t("profile.links.myPurchases"),
          src: require("@/assets/newImges/profile/nav/my-purchases.png"),
          link: "MyPurchases"
        },
        {
          label: this.$t("profile.links.mySales"),
          src: require("@/assets/newImges/profile/nav/my-sales.png"),
          link: "MySales"
        },
        {
          label: this.$t("profile.links.notifications"),
          src: require("@/assets/newImges/profile/nav/notifications.png"),
          link: "Notifications",
          counter: true
        },
        {
          label: this.$t("profile.notifications.messages"),
          src: require("@/assets/newImges/profile/nav/messages.png"),
          link: "Messages",
          counterMessage: true
        },
        // {
        //   label: this.$t("profile.links.sugestions"),
        //   src: require("@/assets/icons/sugestions.png"),
        //   link: "Sugestions"
        // },
        {
          label: this.$t("profile.links.myBuyers"),
          src: require("@/assets/newImges/profile/nav/my-buyers.png"),
          link: "MyBuyers"
        },
        {
          label: this.$t("profile.links.mySellers"),
          src: require("@/assets/newImges/profile/nav/my-sellers.png"),
          link: "MySellers"
        }
      ];
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    test() {
      console.log(this.$refs.profileLinks.scrollHeight);
      this.showNav = !this.showNav;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss" scoped>
.profile-wrapper-background {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .profile-wrapper {
    display: flex;
    height: 100%;
    max-width: 1600px;
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    .profile-links {
      width: 260px;
      min-width: 260px;
      border-right: 1px solid #eaeaea;
      // overflow-x: scroll;
      scroll-behavior: smooth;
      @import "@/assets/scss/scrollbarStyles.scss";
      @include scrollbar;
      .link-wrapper {
        display: flex;
        margin-bottom: 40px;
        cursor: pointer;
        transition: 0.3s;
        align-items: center;
        justify-content: left;
        text-decoration: none;
        color: $blue-400;
        span {
          font-weight: bold;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }
        .image-wrapper {
          .img-helper {
            position: relative;
            img {
              transition: opacity 0.3s;
              opacity: 0.4;
            }
          }
          width: 30px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 2px;
        }
      }
      .link-wrapper.router-link-active {
        img {
          opacity: 1 !important;
        }
        color: $blue-1000;
      }
      .link-wrapper:last-child {
        margin-bottom: 0px;
      }
      .link-wrapper.admin a {
        font-weight: bold;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: $light-blue-600;
        text-decoration: none !important;
      }
    }
    .content {
      flex-grow: 1;
      overflow-y: auto;
      @import "@/assets/scss/scrollbarStyles.scss";
      @include scrollbar;
      padding-right: 5px;
    }
  }
}

@media only screen and (max-width: 1000px) {
  .profile-wrapper {
    display: flex;
    flex-direction: column;
    width: 100% !important;
    padding: 40px 20px !important;
    .open-drawer {
      font-size: 2rem;
      color: $light-blue-900;
      .icon {
        transition: transform 0.5s;
        cursor: pointer;
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
    .profile-links {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      width: 100% !important;
      overflow: auto;
      min-width: 0px !important;
      border-right: 0px hidden !important;
      // border-bottom: 1px solid #EAEAEA;
      // display: -webkit-box;
      overflow: hidden;
      transition: max-height 0.5s;
      max-height: 0px;

      .link-wrapper {
        display: flex;
        margin-bottom: 20px !important;
        cursor: pointer;
        align-items: center;
        transition: 0.3s;
        span {
          font-weight: 400;
          line-height: 26px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          white-space: nowrap;
          padding: 0 5px;
        }
        .image-wrapper {
          display: flex;

          justify-content: center;
          align-items: center;
          .img-helper {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              filter: grayscale(1);
            }
          }
        }
      }
      .link-wrapper.active {
        border-bottom: 1px solid;
      }
    }

    .content {
      width: 100%;
      padding-right: 0px;
      margin: 0 auto;
      overflow-y: auto;
      @import "@/assets/scss/scrollbarStyles.scss";
      @include scrollbar;
      box-sizing: border-box;
      padding-right: 5px;

      .profile-my-sales-wrapper,
      .profile-my-purchases-wrapper {
        padding-left: 0px;
        width: 100%;
        margin: 0 auto;
      }
    }
  }
}
@media only screen and (max-width: 400px) {
  .profile-links {
    // width: 110px !important;
    // overflow: scroll;
    scroll-behavior: smooth;
  }
}
.swing-in-top-fwd {
  -webkit-animation: swing-in-top-fwd 0.5s
    cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@-webkit-keyframes swing-in-top-fwd {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes swing-in-top-fwd {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
